import React, { useContext, useRef } from 'react';
import type { FC } from 'react';
import { makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import Hero from './Hero';
import Features from './Features';
import Testimonials from './Testimonials';
import Presentation from './Presentation';
import CTA from './CTA';
import FAQS from './FAQS';
import ContactUs from './contactUs';
import Subsciption from './Subsciption';
import Footer from './Footer';
import AppContext from 'src/contexts/AppContext';

const useStyles = makeStyles(() => ({
  root: {}
}));

const HomeView: FC = () => {
  const classes = useStyles();
  const { executeScroll, subscriptionSectionRef: subscriptionRef } = useContext(AppContext);

  return (
    <Page
      className={classes.root}
      title="Home"
    >
      <Hero executeScroll={executeScroll}/>
      <CTA executeScroll={executeScroll} />
      {/* <WhyChooseUs/> */}
      {/* <Features /> */}
      {/* <Testimonials /> */}
      {/* <Presentation />
      <CTA />
      <FAQS /> */}

      {/* <ContactUs /> */}
      <Subsciption subscriptionRef={subscriptionRef}/>
      <Footer />
    </Page>
  );
};

export default HomeView;
